import { ReactNode } from 'react'

import styles from './plain-checkbox.module.scss'

type Props = {
  children: ReactNode
}

const LevelShift = ({ children }: Props) => {
  return <div className={styles.level1}>{children}</div>
}

export default LevelShift
